export default "__VITE_ASSET__CyH8Owny__"